/**
 * "/" — sends the person to the first platform they administer (Retail first, as the portal's
 * home since 2026-05-14). With none, it says where each platform stands.
 */

import { Navigate } from 'react-router';
import { PageHeader } from '@retail-ops/panel-shell';
import { usePlatforms, PLATFORMS } from '@/contexts/PlatformsContext';
import { CONSENT_WAITING_MESSAGE } from '@/auth/tokens';

export function PortalHome(): JSX.Element {
  const { available, status, loading } = usePlatforms();
  if (available[0]) return <Navigate to={available[0].path} replace />;
  if (loading) return <div className="loading-inline">Checking which platforms you administer…</div>;
  return (
    <div>
      <PageHeader title="Admin portal" intro="You have no admin rights in any platform yet. Where each platform stands for you:" />
      <ul className="link-list">
        {PLATFORMS.map((pl) => {
          const st = status[pl.id];
          const text =
            st.kind === 'consent-waiting'
              ? CONSENT_WAITING_MESSAGE
              : st.kind === 'unavailable'
                ? 'Not yet available'
                : st.kind === 'error'
                  ? `Could not check: ${st.message}`
                  : 'No admin rights';
          return (
            <li key={pl.id}>
              <strong>{pl.label}</strong>: {text}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
